import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, share } from 'rxjs/operators';

/**
 * Dupla küldés elleni védelem: ha ugyanaz a módosító kérés (metódus, cím, tartalom) még folyamatban van,
 * a második (dupla kattintás, gyors ismétlés) nem indul el újra, hanem az első válaszát kapja meg.
 * A korrelációs azonosító minden híváskor új, ezért a kulcsba nem számít bele. Fájlfeltöltést (FormData) nem érint.
 */
@Injectable()
export class SzDedupeInterceptor implements HttpInterceptor {
  private inFlight = new Map<string, Observable<HttpEvent<any>>>();

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const key = this.keyOf(request);
    if (!key) {
      return next.handle(request);
    }
    const running = this.inFlight.get(key);
    if (running) {
      return running;
    }
    const shared = next.handle(request).pipe(
      finalize(() => this.inFlight.delete(key)),
      share()
    );
    this.inFlight.set(key, shared);
    return shared;
  }

  private keyOf(request: HttpRequest<any>): string | null {
    if (!['POST', 'PUT', 'DELETE', 'PATCH'].includes(request.method)) {
      return null;
    }
    const body = request.body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return null;
    }
    let text = '';
    if (body != null) {
      if (typeof body === 'string') {
        text = body;
      } else {
        try {
          text = JSON.stringify(body, (k, v) => (k === 'correlationId' ? undefined : v));
        } catch {
          return null;
        }
      }
    }
    return `${request.method} ${request.urlWithParams} ${text}`;
  }
}
